import React from 'react';
import './AdminCommunityLoading.css';

const figures = [
    { color: 'pink', path: 'M 107 39 C 108 77 84 113 42 108', cx: 57, cy: 63 },
    { color: 'teal', path: 'M 215 108 C 178 110 145 79 149 39', cx: 199, cy: 63 },
    { color: 'violet', path: 'M 148 216 C 146 178 181 146 216 149', cx: 199, cy: 198 },
    { color: 'amber', path: 'M 41 148 C 80 145 111 178 108 216', cx: 57, cy: 198 },
];

export default function AdminCommunityLoading({ text, fullScreen = false, offline = false, compact = false }: {
    text: string;
    fullScreen?: boolean;
    offline?: boolean;
    compact?: boolean;
}) {
    const layout = fullScreen ? 'community-loading--overlay' : compact ? 'community-loading--compact' : 'cowork-loading-state';

    return (
        <div className={`community-loading ${layout}${offline ? ' community-loading--offline' : ''}`}
            data-luma-overlay={fullScreen || undefined} role="status" aria-live="polite" aria-atomic="true" aria-busy={!offline}>
            <div className="community-loading__content">
                <svg className="community-loading__mark" viewBox="24 24 208 208" width="32" height="32"
                    fill="none" aria-hidden="true" focusable="false">
                    {figures.map(({ color, path, cx, cy }) => (
                        <g key={color} className={`community-loading__figure--${color}`}>
                            <path className="community-loading__track" d={path} stroke="currentColor" strokeWidth="22" strokeLinecap="round"/>
                            <path className="community-loading__ink" d={path} pathLength="1" stroke="currentColor" strokeWidth="22" strokeLinecap="round"/>
                            <circle cx={cx} cy={cy} r="17" fill="currentColor"/>
                        </g>
                    ))}
                </svg>
                <div className="community-loading__copy">
                    <p className="community-loading__title">{offline ? 'Sin conexión a internet' : text}</p>
                    {offline && <p className="community-loading__caption">Revisa tu conexión. Continuaremos cuando vuelvas.</p>}
                </div>
            </div>
        </div>
    );
}
